module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/vendor/vendor-admin.component.css
// module id = ./src/app/admin/vendor/vendor-admin.component.css
// module chunks = main